module.exports = __webpack_public_path__ + "img/training.6cfbb3b9.svg";